<template>
  <div class="train-container">
    <div class="breadcrumb">
      <div class="integralBreadcrumb">
        <div @click="routerHandle('onlineTraining')">首页</div>
        <div class="el-icon-arrow-right jt"></div>
        <div @click="routerHandle('courseList')">课程列表</div>
        <div class="el-icon-arrow-right jt"></div>
        <div>课程详情</div>
      </div>
      <div class="cusService">
        <a @click="$consultJump($store.state.user)"
                      class="consult">
          <img src="@/assets/img/cusService.png"
                alt=""
                class="img_cusService" />
          联系客服
        </a>
      </div>
    </div>
    <!-- 课程简介 -->
    <!--  -->
    <div class="course-info"
         v-if="courseInfo">
      <div class="info-row"
           id="playjump">
        <div class="prism-player"
             id="J_prismPlayer"
             v-show="player">
          <span class="J_prismPlayer_info">登录用户：{{$store.state.user.userNickname || ''}}</span>
        </div>
        <img width="477"
             height="270"
             v-show="!player"
             :src="courseInfo.logoUrl || imgUrl"
             alt="暂无图片" />
        <div class="course-about">
          <div class="info-name">{{courseInfo.courseName}}</div>
          <div class="info-teacher-name">
            主讲老师：
            <span class="info-value">{{courseInfo.mainTeachers}}</span>
          </div>
          <div class="info-teacher-name">
            课程有效期：
            <span class="info-value">{{courseInfo.loseType === '1' ? '购买之日起' + courseInfo.loseTime + '天' : courseInfo.endTime?courseInfo.endTime.slice(0, 10): ''}}</span>
          </div>
          <div class="info-teacher-name">
            咨询电话：
            <span class="info-value">4008876000</span>
          </div>
          <div v-if="activityType === 2 || (activityType === 3 && !isFree)"
               class="seckillBox">
            <div v-if="activityType === 2"
                 class="seckillTitle">限时免费</div>
            <div v-if="activityType === 3  && !isFree"
                 class="seckillTitle">限时秒杀</div>
            <div class="countDownFather" v-show="activityType === 3  && !isFree">
              距离{{seckillStart?'结束':'开始'}}：
              <count-down class="countDownBox"
                          v-on:end_callback="seckillEndFun"
                          v-on:start_callback="seckillStartFun"
                          :currentTime="currentTime"
                          :startTime="startTime"
                          :endTime="endTime"
                          :tipText="'距离活动开始时间开始还有'"
                          :tipTextEnd="'距离活动结束还剩'"
                          :endText="'活动已结束'"
                          :dayTxt="'天'"
                          :hourTxt="':'"
                          :minutesTxt="':'">
              </count-down>
            </div>
          </div>
          <div class="course-about-bottom"
               v-if="courseInfo.activityType === 3 && inActivityTime">
            <div class="">秒杀价</div>
            <div class="sale-price">{{(isFree ? '免费' : '￥' +(courseInfo && courseInfo.activitySeckillPrice ? courseInfo.activitySeckillPrice : 0))}}</div>
            <!-- '免费' -->
            <div class="origin-price">
              <!-- 原价 -->&nbsp;￥&nbsp;{{courseInfo.coursePrice}}
            </div>
          </div>
          <div class="course-about-bottom"
               v-else-if="courseInfo.activityType === 2 && inActivityTime">
            <div class="">秒杀价</div>
            <div class="sale-price">{{(isFree ? '免费' : '￥' +(courseInfo && courseInfo.activitySeckillPrice ? courseInfo.activitySeckillPrice : 0.00))}}</div>
            <!-- '免费' -->
            <div class="origin-price">
              <!-- 原价 -->&nbsp;￥&nbsp;{{courseInfo.coursePrice}}
            </div>
          </div>
          <div class="course-about-bottom"
               v-else>
            <div class="">活动价：</div>
            <div class="sale-price">{{(isFree ? '免费' : '￥' + (courseInfo && courseInfo.currentPrice ? courseInfo.currentPrice : 0))}}</div>
            <!-- '免费' -->
            <div class="origin-price">
              <!-- 原价 -->&nbsp;￥&nbsp;{{courseInfo.coursePrice}}
            </div>
          </div>
        </div>
      </div>
      <div class="info-row"
           style="margin-top: 20px;margin-bottom: 10px;">
        <div class="course-data">
          <div class="data-item padding-right">
            <div class="item-number">{{courseInfo.salesVolumes}}</div>
            <div class="item-option">购买数</div>
          </div>
          <div class="data-item padding-right padding-left">
            <div class="item-number">{{courseInfo.lessionNum}}</div>
            <div class="item-option">课时数</div>
          </div>
          <div class="data-item padding-left">
            <div class="item-number">{{courseInfo.viewCount}}</div>
            <div class="item-option">浏览数</div>
          </div>
          <div class="lick-icon" @click.stop="changeLikeState">
            <img class="k-docview-likeicon"
                   alt="收藏"
                   :src="courseInfo.collectionDataId ? likeUrl : notLikeUrl"
                   />
                   {{courseInfo.collectionDataId ? '已收藏' : '收藏'}}

          </div>
        </div>
        <div class="course-about operation">
          <template v-if="isFree">
            <button class="button"
                    @click.stop="clickReceive">
              立即播放
            </button>
          </template>
          <template v-else>
            <button :class="'button'+(butLoading?' but-loading':'') + (isBan?' forbidden':'')"
                    @click.stop="goBuy()"
                    v-show="!isFree || !courseInfo.bought">
              <i class="el-icon-loading"
                v-show="butLoading"></i>
              立即购买
            </button>
            <button :class="'button shop-cart-but'+(butLoading?' but-loading':'')+ (isBan?' forbidden':'')"
                    @click.stop="addshopcart()"
                    v-show="!isFree || !courseInfo.bought">
              <i class="el-icon-loading"
                v-show="butLoading"></i>
              加入购物车
            </button>
          </template>
          <!-- <div class="share"
               @click.stop="share()">
            <img width="16"
                 height="16"
                 src="@/assets/img/share.png" />
            分享
          </div> -->
        </div>
      </div>
    </div>
    <!-- 课程详情 -->
    <div class="course">
      <div class="course-left">
        <div class="course-tarbar-box">
          <div class="course-tarbar">
            <a class="course-tarbar-item"
              :class="{ 'course-tarbar-item-selected': tarSelected==='coueseDetail' }"
              @click.stop="changeSelected('coueseDetail')">课程详情</a>
            <a class="course-tarbar-item"
              :class="{ 'course-tarbar-item-selected': tarSelected==='coueseOutline' }"
              @click.stop="changeSelected('coueseOutline')">课程大纲</a>
            <a class="course-tarbar-item"
              :class="{ 'course-tarbar-item-selected': tarSelected==='coueseComment' }"
              @click.stop="changeSelected('coueseComment')">课程评论</a>
            <a class="course-tarbar-item"
              :class="{ 'course-tarbar-item-selected': tarSelected==='coueseTip' }"
              @click.stop="changeSelected('coueseTip')">tip图</a>
          </div>
          <div class="link-to">
            <span class="link-btn" @click="$router.push({name: 'PostBar'})"><img src="@/assets/img/贴吧.png" alt="">论坛贴吧</span>
            <span class="link-btn" @click="$router.push({name: 'ExpertsQuestion'})"><img src="@/assets/img/专家问答.png" alt="">专家问答</span>
          </div>
        </div>
        <div class="course-deatil">
          <div id="coueseDetail"
               class="tarbar-item">
            <div class="top-bg"></div>
            <div>课程详情</div>
          </div>
          <div id="detailHtml"
               class="course-deatil-content"
               v-if="courseInfo&&courseInfo.courseContext"
               v-html="decodeURIComponent(courseInfo.courseContext)"></div>
          <div v-else
               class="course-deatil-content no-content">没有相关数据，小编正在努力整理中...</div>
          <div id="coueseOutline"
               class="tarbar-item">
            <div class="top-bg"></div>
            <div>课程大纲</div>
          </div>
          <div class="course-deatil-content">
            <el-tree :data="courseChapter"
                     :props="chapterProps"
                     :default-expand-all='true'
                     @node-click="handleNodeClick"
                     @node-expand="handleNodeClick"
                     node-key="id">
              <div class="custom-tree-node"
                   slot-scope="{ data }"
                   style="">
                   <div>
                    <span style="margin-right:10px" v-if="data.childChapter">章节{{data.index}}</span>
                    <span style="" v-if="!data.childChapter">课程{{data.indexChildren}}</span>
                    <el-tag v-if="!data.childChapter">视频</el-tag>
                    <span>{{ data.name }}</span>
                   </div>
                <span style="color:green;"
                      v-if="data.chapterType===2&&(data.free || isFree || !(courseInfo&&!courseInfo.bought))">{{data.free || isFree?'免费试听':(courseInfo&&courseInfo.bought)?'观看':''}}</span>
              </div>
            </el-tree>
          </div>
          <div id="coueseComment"
               class="tarbar-item">
            <div class="top-bg"></div>
            <div>课程评论</div>
          </div>
          <!-- 去评价 -->
          <div class="couese-comment">
            <img class="comment-author-img"
                 :src="$store.state.user.userAvatarUrl || imgUrl"
                 width="42"
                 height="42" />
            <div class="comment-deatil">
              <div class="comment-author-name">{{$store.state.user.userNickname||'游客'}}</div>
              <textarea :disabled="!isLogin"
                        maxlength="500"
                        v-model="courseComment"
                        class="comment-content-textarea"
                        rows="6"
                        placeholder="请输入评论内容...(最长500字)" />
              <div class="comment-but">
                <button :class="'button shop-cart-but submit'+(butLoading?' but-loading':'')+ (isBan?' forbidden':'')"
                        @click="replay()"
                        :disabled="!isLogin">
                  <i class="el-icon-loading"
                     v-show="butLoading"></i>
                  我来评论
                </button>
              </div>
            </div>
          </div>
          <!-- 评论列表 -->
          <div v-if="!(commentList&&commentList.length)"
               class="course-deatil-content no-content">还没有评论，快来抢沙发吧...</div>
          <div v-else
               class="couese-comment comment-list"
               v-for="(item, index) in commentList"
               :key="item.id">
            <img class="comment-author-img"
                 :src="item.userAvatarURL || imgUrl"
                 width="42"
                 height="42" />
            <div class="comment-deatil">
              <div class="comment-author-name">{{item.userNickname || '匿名'}}</div>
              <div class="comment-content">{{item.content}}</div>
              <div class="comment-time-info">
                <div class="comment-time">发表于{{item.createTime}}</div>
                <div class="comment-time">
                  <div class="comment-icon"
                       title="评论"
                       @click="replayIndex = replayIndex === index ? -1: index;commentComment='' ">{{item.replyCount || 0}}</div>
                  <div class="praise-icon"
                       title="赞一下"
                       @click.stop="commentPraise(item.id)">{{item.praiseCount || 0}}</div>
                </div>
              </div>
              <div v-show="replayIndex === index">
                <textarea :disabled="!isLogin"
                          maxlength="500"
                          v-model="commentComment"
                          class="comment-comment-content-textarea"
                          rows="6"
                          placeholder="请输入评论内容...(最长500字)" />
                <div class="comment-but">
                  <button :class="'button shop-cart-but'+(butLoading?' but-loading':'')"
                          @click="replay(item.id)"
                          :disabled="!isLogin">
                    <i class="el-icon-loading"
                       v-show="butLoading"></i>
                    我来回复
                  </button>
                </div>
                <!-- 评论的评论 -->
                <div class="couese-comment"
                     v-for="commentVo in item.commentVos"
                     :key="commentVo.id">
                  <img class="comment-author-img"
                       :src="commentVo.userAvatarURL || imgUrl"
                       width="42"
                       height="42" />
                  <div class="comment-deatil">
                    <div class="comment-author-name">{{commentVo.userNickname || '匿名'}}</div>
                    <div class="comment-content-item">{{commentVo.content}}</div>
                    <div class="comment-time-info">
                      <div class="comment-time">发表于{{commentVo.createTime}}</div>
                      <div class="comment-time">
                        <!-- <div class="comment-icon">{{commentVo.replyCount || 0}}</div> -->
                        <div class="praise-icon"
                             title="赞一下"
                             @click.stop="commentPraise(commentVo.id)">{{commentVo.praiseCount || 0}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 分页 -->
          <div class="doclist-pagination"
               v-if="commentList&&commentList.length">
            <div class="doclist-lastpage"
                 @click="jumpLastPage">上一页</div>
            <div class="doclist-omit">{{lastOmit}}</div>
            <ul>
              <li :class="item === currentPage?'pageactive':''"
                  v-for="item in pageList"
                  :key="item"
                  @click="changePageTo(item)">{{item}}</li>
            </ul>
            <div class="doclist-omit">{{nextOmit}}</div>
            <div class="doclist-nextpage"
                 @click="jumpNextPage">下一页</div>
            <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text"
                     v-model.number="jumpTargetPage">页</div>
            <div class="doclist-jump"
                 @click="jumpFarPage">确定</div>
          </div>
          <div id="coueseDetail"
               class="tarbar-item">
            <div class="top-bg"></div>
            <div>tip图</div>
          </div>
          <div id="coueseTip"
               class="course-deatil-content">
              <img :src="courseInfo.tipUrl" v-if="courseInfo&&courseInfo.tipUrl">
          </div>
        </div>
      </div>
      <div class="course-right">
        <!-- 主讲讲师 -->
        <div class="main-teacher">
          <div id="coueseComment"
               class="tarbar-item">
            <div class="top-bg"></div>
            <div>主讲讲师</div>
          </div>
          <div class="teacher"
               v-for="item in teacherList"
               :key="item.id">
            <div class="techer-img">
              <!-- item. -->
              <img :src="item.url || imgUrl"
                   width="68"
                   height="68"
                   @click.stop="goTeacherDetail(item.id)" />
              <div class="techer-name overell"><span class="techer-name-span"
                      @click.stop="goTeacherDetail(item.id)">{{item.name}}</span></div>
              <p class="techer-instr">{{item.career}}</p>
            </div>
          </div>
        </div>
        <!-- 学过此课程的人 -->
        <div class="main-teacher">
          <div id="coueseComment"
               class="tarbar-item">
            <div class="top-bg"></div>
            <div>学过此课程的人({{courseStudyhistory && courseStudyhistory.length || 0}})</div>
          </div>
          <div class="user-list">
            <div v-if="!(courseStudyhistory&&courseStudyhistory.length)"
                 class="no-content">还没有人学过此课程，快去学习吧...</div>
            <div v-else
                 :class="'user-info '+(index%4!==0?'margin-left':'')"
                 v-for="(item, index) in courseStudyhistory"
                 :key="index">
              <img class="user-img"
                   :src="item.userAvatarURL || imgUrl"
                   width="48"
                   height="48" />
              <div class="user-name overell"
                   :title="item.userName">{{item.userName}}</div>
              <!--  -->
            </div>
          </div>
        </div>
        <!-- 猜你想学 -->
        <div class="main-teacher">
          <div id="coueseComment"
               class="tarbar-item">
            <div class="top-bg"></div>
            <div>猜你想学</div>
          </div>
          <div class="course-list">
            <div v-if="!(maybeYouWant&&maybeYouWant.length)"
                 class="no-content">没有相关数据，小编正在整理中...</div>
            <div v-else
                 class="course-name"
                 v-for="item in maybeYouWant"
                 :key="item.id">
              《<div class="course-name-middle overell"
                   @click.stop="goCourseDetail(item.id)">{{item.courseName}}</div>》
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog width="608px"
               :visible.sync="dialogVisible">
      <div class="isFinished"><img src="@/assets/img/isFinished.png"
             alt=""></div>
      <p class="isFinishedMessage">恭喜您完成本课程&nbsp;&nbsp;欢迎继续学习以下课程</p>
      <div class="courseBoxList">
        <div v-for="(item, index) in recommendCourseList"
             :key="item.id"
             class="courseDiv box-shadow"
             :class="index%1!==0? 'course-margin' :''">
          <div class="course-img"
               @click="goCourseDetail(item.id)">
            <img :src="item.url || '~@/assets/img/占位图_en.png'"
                 :alt="item.name"
                 width="283px"
                 height="160px" />
          </div>
          <div class="recCourse-name overell"
               @click="goCourseDetail(item.id)">{{item.courseName}}</div>
          <div class="recCourse-info">
            购买数：{{item.salesVolumes}}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import CountDown from '../common/countDown'
import { getAccessToken } from '@/utils/userInfo'
import PlaylistComponent from './PlaylistComponent'
export default {
  data () {
    return {
      inActivityTime: false,
      seckillStart: false,
      trainCourseStudyhistoryId: '',
      courseStudyTimeId: '',
      imgUrl: require('@/assets/img/bitmap_en.png'),
      videoList: [], // 可播放视频列表（已购买 免费）
      currentPlayVideoId: '', // 当前播放视频的id
      dialogVisible: false, // 推荐课程弹窗
      recommendCourseList: [], // 推荐课程列表
      isLastCouseItem: false, // 判断是否最后一张
      lastCouseItemId: null, // 最后一个视频的id
      isBan: false, // 禁用状态
      butLoading: false, // loding
      tarSelected: 'coueseDetail', // 锚点标示
      courseInfo: {}, // 课程详情
      courseChapter: [], // 章节列表
      teacherList: [], // 主讲教师列表
      courseStudyhistory: [], // 课程学习历史
      maybeYouWant: [], // 猜你想学
      player: null, // 播放器
      palyerStatus: false, // 视频播放状态
      commentList: [], // 评论列表
      replayIndex: -1,
      courseComment: '', // 课程评论
      commentComment: '', // 评论评论
      // 分页
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1, // 跳转页
      chapterProps: {
        children: 'childChapter',
        label: 'name'
      },
      chineseIndexList: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'],
      // 收藏后红心icon的base64码
      likeUrl:
        'data:image/png;base64,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',
      // 未收藏时蓝心icon的base64码
      notLikeUrl:
        'data:image/png;base64,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'
      // seeked: false
    }
  },
  components: {
    CountDown
  },
  computed: {
    activityType (val) {
      return this.courseInfo.activityType
    },
    currentTime (val) {
      return parseInt(this.courseInfo.sysDate ? new Date(this.courseInfo.sysDate).getTime() : new Date().getTime())
    },
    startTime (val) {
      // return parseInt(new Date('2024-06-04 18:59:00').getTime())
      return parseInt(new Date(this.courseInfo.activityStartTime).getTime())
    },
    endTime (val) {
      // return parseInt(new Date('2024-06-04 19:01:00').getTime())
      return parseInt(new Date(this.courseInfo.activityEndTime).getTime())
    },
    courseId () {
      return this.$route.query.id
    },
    isLogin () {
      return getAccessToken()
    },
    isFree () {
      return !!(this.courseInfo && (this.courseInfo.free === true || Number(this.courseInfo.currentPrice) <= 0))
    },
    chapterId () { // 学习记录id
      return this.$route.query.chapterId
    }
  },
  created () {
    window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
  destroyed () {
    window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
    // 去除键盘监听
    document.onkeydown = null
  },
  watch: {
    courseId (val) {
      this.player = null
      if (val) {
        this.getCourseInfo()
        this.getCommentList(1)
      }
    }
  },
  mounted () {
    // console.log('this.chapterId')
    // console.log(this.chapterId)
    this.getCourseInfo()
    this.getCommentList(this.currentPage)
  },
  methods: {
    // 是否在秒杀时间内
    isActivityDuration () {
      let flag = false
      if (this.startTime && this.endTime) {
        flag = this.currentTime > this.startTime && this.currentTime < this.endTime
      } else {
        flag = false
      }
      this.inActivityTime = flag
    },
    // 获取历史课程index
    getCourseIndex (chapterId, videoList) {
      // console.log('getCourseIndex---------')
      // console.log(chapterId)
      // console.log(videoList)
      return videoList.findIndex((item, index) => {
        return item.id === chapterId
      })
    },
    beforeunloadFn () {
      if (this.trainCourseStudyhistoryId) {
        this.$http.post(`/front/train/trainCourseStudyhistory/recordEndTime`, {
          'id': this.trainCourseStudyhistoryId,
          'courseStudyTimeId': this.courseStudyTimeId
        }).then(({ data: res }) => {
          if (res && res.code === 0) {
            // console.log(res)
          }
        })
      }
    },
    seckillStartFun (val) {
      console.log('start', val)
      this.seckillStart = val
      this.isActivityDuration()
    },
    // 倒计时结束回调
    seckillEndFun () {
      console.log('end')
      // this.getCourseInfo()
      this.isActivityDuration()
    },
    routerHandle (routerName) {
      if (routerName) {
        let query = {}
        if (routerName === 'courseList') {
          query = JSON.parse(sessionStorage.getItem('courseQuery'))
        }
        this.$router.push({ name: routerName, query: query })
      }
    },
    // 锚点跳转
    changeSelected (val) {
      this.tarSelected = val
      document.getElementById(val).scrollIntoView()
    },
    // 获取课程详情
    getCourseInfo () {
      // console.log('getCourseInfo')
      this.courseInfo = {}
      this.courseChapter = []
      this.teacherList = []
      this.courseStudyhistory = []
      this.maybeYouWant = []
      this.videoList = []
      this.currentPlayVideoId = ''
      this.lastCouseItemId = ''
      this.$http.get(`/front/train/trainCourse/courseInfo/${this.courseId}`)
        .then(({ data: res }) => {
          if (res && res.code === 0) {
            this.isBan = false
            this.courseInfo = res.data.courseInfo
            this.courseChapter = res.data.courseChapter || []
            this.setIndex(this.courseChapter)
            this.teacherList = res.data.teacherList
            this.courseStudyhistory = res.data.courseStudyhistory
            this.maybeYouWant = res.data.maybeYouWant
            // 未登录不可观看
            if (!getAccessToken()) {
              return false
            }
            var video = []
            this.courseChapter.forEach(menu => {
              if (menu.chapterType === 2) {
                video.push(menu)
              } else if (menu.childChapter) {
                video.push(...menu.childChapter)
              }
            })
            let videoList = []
            if (this.isFree || this.courseInfo.bought) {
              // 免费
              videoList = video
            } else {
              this.courseChapter.forEach(menu => {
                if (menu.chapterType === 2 && menu.free === true) {
                  videoList.push(menu)
                } else if (menu.chapterType === 1 && menu.childChapter) {
                  if (menu.free === true) {
                    videoList.push(...menu.childChapter)
                  } else {
                    menu.childChapter.forEach(child => {
                      if (child.free === true) {
                        videoList.push(...child)
                      }
                    })
                  }
                }
              })
            }
            this.videoList = videoList
            // 最后一节课ID
            if (video.length) {
              this.lastCouseItemId = video[video.length - 1].id
            } else {
              this.lastCouseItemId = ''
            }
            let historyIndex = this.getCourseIndex(this.chapterId, videoList)
            // console.log('111231231')
            // console.log(historyIndex)
            if (this.videoList.length && !historyIndex) {
              this.getVideoInfo(videoList[0].content, videoList[0])
            } else if (this.videoList.length && historyIndex) {
              this.getVideoInfo(videoList[historyIndex].content, videoList[historyIndex])
            }
            this.isActivityDuration()
          } else {
            this.isBan = true
          }
        }).catch(() => { })
    },
    // 设置下标
    setIndex (val) {
      // console.log('setIndex')
      // console.log(val)
      try {
        val.forEach((item, index) => {
          this.courseChapter[index].index = this.transformIndex(index)
          if (item.childChapter && item.childChapter.length > 0) {
            item.childChapter.forEach((item, indexChildren) => {
              this.courseChapter[index].childChapter[indexChildren].indexChildren = indexChildren + 1
            })
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    // 转换中文数字
    transformIndex (index) {
      index = index + ''
      let indexList = index.split('')
      let str = ''
      indexList.forEach((item, index) => {
        str += this.chineseIndexList[item]
      })
      return str
    },
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   第几页
    changePageTo (page) {
      this.getCommentList(page)
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        this.changePageTo(this.jumpTargetPage)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    setPageTo (page) {
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    // 获取评论列表
    getCommentList (currentPage) {
      if (this.isBan) {
        return false
      }
      this.commentList = []
      this.totalPage = 0
      this.$http.post(`/front/train/trainComment/listCourseCommentsAtDetailPage`, {
        'page': currentPage,
        'limit': 10,
        'id': this.courseId
      }).then(({ data: res }) => {
        if (res && res.code === 0) {
          this.commentList = res.data.data || []
          this.totalPage = Math.ceil((res.data.count || 0) / 10)
        }
        this.setPageTo(currentPage)
      }).catch(() => {
        this.setPageTo(0)
      })
    },
    // 回复评论
    replay (id) {
      if (this.butLoading || this.isBan) {
        return false
      }
      if ((id && this.commentComment === '') || ((!id) && this.courseComment === '')) {
        this.$message.warning('评论内容不能为空')
        return false
      } else {
        if ((id && this.commentComment.length > 500) || ((!id) && this.courseComment.length > 500)) {
          this.$message.warning('评论内容不能超500')
          return false
        }
      }
      this.butLoading = true
      this.$http.post(`/front/train/trainComment/saveCourseComment`, {
        content: id ? this.commentComment : this.courseComment,
        businessId: this.courseId,
        pCommentId: id || ''
      }).then(({ data: res }) => {
        if (res && res.code === 0) {
          this.getCommentList(this.currentPage)
          if (id) {
            this.commentComment = ''
          } else {
            this.courseComment = ''
          }
          this.$message.success('评论成功')
        } else {
          // 错误
          // this.$message.error(res.msg || '评论失败')
        }
      }).finally(() => {
        this.butLoading = false
      })
    },
    goTeacherDetail (id) {
      if (this.isBan) {
        return false
      }
      this.$router.push({ name: 'teacherInfo', query: { id: id } })
    },
    goCourseDetail (id) {
      if (this.isBan) {
        return false
      }
      this.$http.post(`/front/train/trainQuestionAnswer/plusViewCount`, {
        type: 2, // type --1:新闻/2：课程/3：图书/4：问答
        id: id
      })
      this.$router.push({ name: 'courseDetail', query: { id: id } })
    },
    // 加入购物车
    addshopcart () {
      if (!this.isLogin) {
        this.pleaseLogin()
        return false
      }
      if (this.butLoading || !this.courseId || this.isBan) {
        return false
      }
      this.butLoading = true
      this.$http.post(`/front/train/trainShoppingCart/addGoodsToCart`,
        {
          'goodsCategory': 'course', // 商品类型  course:课程、realdoc:实体书，doc：电子书
          'goodsId': this.courseId, // 商品id
          'num': 1 // 购买数量
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            // this.$router.push({ name: 'ShopCart' })
            this.$store.dispatch('setShoppingCartCount', this.$store.state.shoppingCartCount + 1)
            this.$message.success(this.$t('message.addCartSuccess'))
          } else {
            // this.$message.error(res.msg || '加入购物车失败')
          }
        })
        .finally(() => {
          this.butLoading = false
        })
    },
    // 分享返利
    share () {
      this.$confirm(
        `请登录plantmate APP，享受分享返利`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {})
        .catch((e) => {})
    },
    // 立即购买
    goBuy () {
      if (!this.isLogin) {
        this.pleaseLogin()
        return false
      }
      if (this.butLoading || !this.courseId || this.isBan) {
        return false
      }
      this.$router.push({ name: 'settlement', query: { goodsId: this.courseId, type: 1 } })
    },
    pleaseLogin () {
      this.$confirm(
        `请登录`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$router.push({ name: 'login' })
        })
        .catch((e) => {})
    },
    // 属性节点打开
    handleNodeClick (data) {
      console.log(data)
      // console.log(data)
      // debugger
      if (!this.isLogin) {
        this.pleaseLogin()
        return false
      }
      if (data.chapterType === 2) {
        if ((this.courseInfo && (this.isFree || this.courseInfo.bought)) || data.free) {
          // 可以播放
          if (data.content) {
            this.getVideoInfo(data.content, data).then(() => {
              const listHtml = document.querySelector('.playlist-content')
              const videoIndex = this.videoList.findIndex(item => item.content === data.content)
              listHtml && listHtml.querySelector('.video-item.active') && (listHtml.querySelector('.video-item.active').className = 'video-item')
              listHtml && listHtml.querySelector('.list').childNodes[videoIndex] && (listHtml.querySelector('.list').childNodes[videoIndex].className = 'video-item active')
            })
          }
        } else {
          this.$message.warning('请先购买')
        }
      }
    },
    // 评论点赞
    commentPraise (id) {
      if (!this.isLogin) {
        this.pleaseLogin()
        return false
      }
      if (this.butLoading || !this.courseId || this.isBan) {
        return false
      }
      this.butLoading = true
      this.$http.post(`front/train/trainPraise/save`, {
        'targetId': id,
        'type': 4
      }).then(({ data: res }) => {
        if (res.code === 0) {
          this.$message.success('点赞成功')
          this.getCommentList()
        } else {
          // this.$message.error(res.msg || '点赞失败')
        }
      }).finally(() => {
        this.butLoading = false
      })
    },
    getVideoInfo (vid, chapter) {
      // console.log('getVideoInfo')
      // console.log(vid)
      // console.log(chapter)
      // console.log(vid, chapter, this.lastCouseItemId, 'this.lastCouseItemId')
      if (chapter.chapterType === 2 && chapter.id === this.lastCouseItemId) {
        this.isLastCouseItem = true
      } else {
        this.isLastCouseItem = false
      }
      this.currentPlayVideoId = chapter.id
      return this.$http.get(`/front/fileupload/alioss/getVideoPlayAuthInfo?videoId=${vid}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            // console.log('log chufa')
            document.getElementById('playjump').scrollIntoView(true)
            this.addStudyHistory(chapter)
            if (this.player) {
              this.player.replayByVidAndPlayAuth(vid, res.data.playAuth)
            } else {
              const list = this.videoList.map(item => {
                return {
                  name: item.name,
                  click: (videoIndex, callback) => {
                    try {
                      const obj = this.videoList[videoIndex]
                      this.getVideoInfo(obj.content, obj).then(() => {
                        this.player.play()
                        callback()
                      })
                    } catch (e) {
                      console.error(e)
                    }
                  }
                }
              })
              // eslint-disable-next-line no-undef
              this.player = new Aliplayer({
                id: 'J_prismPlayer',
                width: '477px',
                autoplay: false,
                'isLive': false,
                'rePlay': false,
                'playsinline': true,
                'preload': true,
                'controlBarVisibility': 'always',
                'useH5Prism': true,
                // 播放方式一：推荐
                prismType: 2,
                vid: vid,
                playauth: res.data.playAuth,
                showBarTime: 3000000,
                cover: res.data.videoMeta.coverURL,
                // source: 'http://127.0.0.1/getMp4',
                components: [{
                  name: 'PlaylistComponent',
                  type: PlaylistComponent,
                  args: [list]
                }],
                skinLayout: [
                  { name: 'bigPlayButton', align: 'blabs', x: 200, y: 110 },
                  { name: 'H5Loading', align: 'cc' },
                  {
                    name: 'controlBar',
                    align: 'blabs',
                    x: 0,
                    y: 0,
                    children: [
                      { name: 'playButton', align: 'tl', x: 15, y: 13 },
                      { name: 'timeDisplay', align: 'tl', x: 10, y: 6 },
                      { name: 'fullScreenButton', align: 'tr', x: 20, y: 13 },
                      { name: 'volume', align: 'tr', x: 20, y: 11 },
                      { name: 'progress', align: 'tlabs', x: 0, y: 0 },
                      { name: 'setting', align: 'tr', x: 20, y: 13 }

                    ]
                  }
                ]
              })
              this.player.on('ended', () => {
                if (this.isLastCouseItem) {
                  this.$http.get(`/front/train/trainCourse/findRecommendLearning/${this.courseId}`)
                    .then(({ data }) => {
                      if (data.code === 0) {
                        this.recommendCourseList = data.data || []
                      }
                    })
                  this.dialogVisible = true
                } else {
                  this.dialogVisible = false
                  let index = this.videoList.findIndex(item => { return this.currentPlayVideoId === item.id })
                  if (index + 1 <= this.videoList.length) {
                    this.getVideoInfo(this.videoList[index + 1].content, this.videoList[index + 1])
                  }
                }
              })
              // 监听按键状态
              this.watchOnKeyDown()
              // 监听视频播放状态
              this.playerPlay()
              // 事件委托
              this.listenVideoEvent()
            }
          } else {
            this.$message.error(res.msg)
            this.player = null
          }
        }).catch(() => {
          this.player = null
        })
    },
    // 监听全局按键
    watchOnKeyDown () {
      var that = this
      document.onkeydown = function (e) {
        e.stopPropagation()
        e.preventDefault()
        let key = window.event.keyCode
        if (!that.player.getDuration()) return
        // console.log(key)
        if (key === 32) {
          that.clickPlayer()
        }
        if (key === 37) {
          // console.log('监听左')
          let videotimes = that.player.getDuration()
          let playnum = that.player.getCurrentTime()
          playnum = parseInt(playnum - 10)
          if (playnum <= (videotimes - 10)) {
            that.player.seek(playnum)
          }
        } else if (key === 39) {
          // console.log('监听右')
          let videotimes = that.player.getDuration()
          let playnum = that.player.getCurrentTime()
          playnum = parseInt(playnum + 10)
          if (playnum <= (videotimes + 10)) {
            that.player.seek(playnum)
          }
        }
      }
    },
    // 监听点击事件
    listenVideoEvent () {
      this.$nextTick(() => {
        let video = document.querySelectorAll('#J_prismPlayer video')[0]
        video.addEventListener('click', () => {
          this.clickPlayer()
        })
      })
    },
    // 点击播放器事件
    clickPlayer () {
      if (this.palyerStatus) {
        this.player.pause()
      } else {
        this.player.play()
      }
    },
    // 监听当前视频播放状态
    playerPlay () {
      this.player.on('play', () => {
        // console.log('视频播放了')
        if (!this.trainCourseStudyhistoryId) return false
        this.$http.post(`/front/train/trainCourseStudyhistory/recordStartTime`, {
          'id': this.trainCourseStudyhistoryId
        }).then(({ data: res }) => {
          if (res && res.code === 0) {
            // console.log(res.data.courseStudyTimeId)
            this.courseStudyTimeId = res.data.courseStudyTimeId
          }
        })
        if (getAccessToken()) {
          this.palyerStatus = true
        } else {
          this.pleaseLogin()
          this.player.pause()
        }
      })
      this.player.on('pause', () => {
        // console.log('视频停止了')
        if (this.trainCourseStudyhistoryId) {
          this.$http.post(`/front/train/trainCourseStudyhistory/recordEndTime`, {
            'id': this.trainCourseStudyhistoryId,
            'courseStudyTimeId': this.courseStudyTimeId
          }).then(({ data: res }) => {
            if (res && res.code === 0) {
              // console.log(res)
            }
          })
        }
        this.palyerStatus = false
      })
    },
    // 免费领取
    clickReceive () {
      if (this.courseChapter && this.courseChapter[0]) {
        if (this.courseChapter[0].childChapter && this.courseChapter[0].childChapter[0]) {
          this.handleNodeClick(this.courseChapter[0].childChapter[0])
        } else {
          this.handleNodeClick(this.courseChapter[0])
        }
      }
    },
    addStudyHistory (chapter) {
      // console.log('log_2 chufa')
      // console.log(this.courseInfo)
      // console.log(this.courseInfo.bought)
      if (chapter.free || this.isFree || (this.courseInfo && this.courseInfo.bought)) {
        // console.log('log_5 chufa')
        this.$http.post(`/front/train/trainCourseStudyhistory/save`, {
          'courseId': this.courseId, // 课程id
          'chapterId': chapter.id, // 章节id
          'type': '1', // -- 1:课程 2:图书
          'courseName': this.courseInfo.courseName, // -- 课程名称
          'chapterName': chapter.name, // -- 章节名
          'free': this.courseInfo.free
        }).then(({ data: res }) => {
          if (res && res.code === 0) {
            // console.log(res)
            // console.log(res.data.trainCourseStudyhistoryId)
            this.trainCourseStudyhistoryId = res.data.trainCourseStudyhistoryId
          }
        })
      }
    },
    changeLikeState () {
      let url = '/front/kc/userInfo/usercollectioninfo/userCollect'
      if (this.courseInfo.collectionDataId) {
        url = '/front/kc/userInfo/usercollectioninfo/cancelUserCollect'
      }
      this.$http.post(url, {
        collectionType: 'TrainCourse',
        'collectionDataId': this.courseId
      })
        .then(({ data }) => {
          if (data.code === 0) {
            if (this.courseInfo.collectionDataId) {
              this.courseInfo.collectionDataId = false
            } else {
              this.courseInfo.collectionDataId = true
            }
          }
        })
    }
  }
}
</script>
<style>
.prism-player .prism-cover {
  z-index: 0 !important;
}
</style>
<style scoped lang='scss'>
/*包含以下五种的链接*/
a {
  text-decoration: none;
}
/*正常的未被访问过的链接*/
a:link {
  text-decoration: none;
}
/*已经访问过的链接*/
a:visited {
  text-decoration: none;
}
/*鼠标划过(停留)的链接*/
a:hover {
  text-decoration: none;
}
/* 正在点击的链接，鼠标在元素上按下还没有松开*/
a:active {
  text-decoration: none;
}
/* 获得焦点的时候 鼠标松开时显示的颜色*/
a:focus {
  text-decoration: none;
}
/* 培训整体 */
.train-container {
  width: 1190px;
  /* padding: 0 20px; */
  margin: 0 auto;
}
.prism-player {
  width: 100%;
  height: 500px;
  position: relative;
}
.prism-player .prism-big-play-btn {
  width: 45px;
  height: 45px;
  background-size: 128px 256px;
  left: 200px !important;
  bottom: 110px !important;
}
.J_prismPlayer_info {
  position: absolute;
  top: 10%;
  left: 10%;
  font-size: 12px;
  color: red;
  font-size: 22px;
  z-index: 999;
}
.course-info {
  background: #fff;
  padding: 20px;
  margin-bottom: 20px;
}
.info-row {
  display: flex;
  /* justify-content: space-around; */
}
/* 课程粗略介绍 */
.course-about {
  position: relative;
  margin-left: 30px;
  /* width: 100%; */
  letter-spacing: 0.9px;
  flex-grow: 1;
}
.course-about .info-name {
  margin-bottom: 20px;
  font-size: 24px;
  color: #333333;
}
.course-about .info-teacher-name {
  margin-bottom: 10px;
}
.info-value {
  color: #000;
  /* font-weight: bold; */
}
.course-about .course-about-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 42px;
  line-height: 42px;
  display: flex;
  /* border: 1px solid #eee; */
}
.course-about-bottom .sale-price {
  font-size: 30px;
  color: #ff3116;
  margin: auto 20px;
}
.course-about-bottom .origin-price {
  text-decoration: line-through;
}
.info-row .course-data {
  width: 477px;
  display: flex;
  align-items: center;
  padding-left: 10px;
}
.lick-icon {
  flex: 1;
  text-align: right;
  align-items: center;
  cursor: pointer;
  img {
    height: 16px;
  }
}
.course-data .data-item {
  text-align: center;
}
.data-item .item-number {
  line-height: 28px;
  font-size: 20px;
  color: #1d65a8;
}
.data-item .item-option {
  font-size: 14px;
  color: #999999;
  letter-spacing: 0.88px;
}
.course-data .padding-right {
  padding-right: 25px;
  border-right: 1px solid #eee;
}
.course-data .padding-left {
  padding-left: 25px;
}
.operation {
  display: flex;
  color: #1d65a8;
  font-size: 16px;
}
.button {
  height: 40px;
  padding: 0 43px;
  background: #1d65a8;
  border: none;
  color: #fff;
  cursor: pointer;
  user-select: none;
}
.shop-cart-but {
  background: #fff;
  border: 1px solid #1d65a8;
  color: #1d65a8;
  margin: 0 10px;
}
.shop-cart-but:hover {
  background: #1d65a8;
  color: #fff;
}
.operation .share {
  line-height: 48px;
  padding-left: 10px;
  cursor: pointer;
  user-select: none;
}
.operation .share img {
  margin-right: 6px;
}
/* 课程详细 */
.course {
  display: flex;
  justify-content: space-between;
}
.course .course-left {
  width: 855px;
  padding: 20px;
  background: #fff;
}
.course-tarbar-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #1d65a8;
  background: #efefef;

}
.course-left .course-tarbar {
  width: 100%;
  display: flex;
  /* height: 40px; */
  /* line-height: 40px; */
  font-size: 14px;
  color: #333333;
}
.link-to {
  display: flex;
  color: #4a84b9;
  cursor: pointer;
  .link-btn {
    width: 80px;
    margin: 0 8px;
    &:hover {
      color: #1d65a8;
    }
    img {
      transform: translate3d(0,0,0);
      margin-right: 4px;
      height: 18px;
    }
  }
}
.course-tarbar .course-tarbar-item {
  padding: 10px 32px;
  cursor: pointer;
  user-select: none;
}
.course-tarbar .course-tarbar-item-selected {
  background: #1d65a8;
  color: #fff !important;
}
.course-left .course-deatil {
  margin-top: 30px;
}
.tarbar-item {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  margin-bottom: 15px;
}
.tarbar-item .top-bg {
  height: 18px;
  width: 3px;
  background: #999999;
  background-color: #999999;
  margin-right: 10px;
}
.course-deatil-content {
  padding-bottom: 30px;
  margin-left: 15px;
  img {
    max-width: 100%;
  }
}
.no-content {
  text-align: center;
}
#detailHtml {
  max-width: 100%;
  word-wrap: break-word;
  white-space: pre-wrap;
}
#detailHtml img {
  max-width: 100%;
}
#detailHtml /deep/ img {
  max-width: 100%;
}
#coueseTip img {
  max-width: 100%;
}
.couese-comment {
  padding-top: 24px;
  display: flex;
  padding-bottom: 20px;
}
.comment-list {
  border-top: 2px solid #eeeeee;
}
.comment-deatil .comment-content {
  max-width: 100%;
  font-size: 14px;
  color: #666666;
  word-wrap: break-word;
  white-space: pre-wrap;
}
.comment-content-item {
  width: 700px;
  font-size: 14px;
  color: #666666;
  word-wrap: break-word;
  white-space: pre-wrap;
}
.comment-deatil .comment-time {
  display: flex;
}
.comment-icon {
  cursor: pointer;
  background: url(~@/assets/img/comment.png) no-repeat 0 3px;
  background-size: 14px 15px;
  text-align: right;
  width: 50px;
  height: 18px;
  line-height: 18px;
  margin-right: 30px;
}
.comment-icon:hover {
  background: url(~@/assets/img/commentHover.png) no-repeat 0 3px;
  background-size: 14px 15px;
}
.praise-icon {
  cursor: pointer;
  background: url(~@/assets/img/praise.png) no-repeat;
  background-size: 14px 15px;
  text-align: right;
  width: 50px;
  line-height: 18px;
  height: 18px;
}
.praise-icon:hover {
  background: url(~@/assets/img/praiseHover.png) no-repeat;
  background-size: 14px 15px;
}
.comment-deatil .comment-time-info {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #999999;
  margin-top: 12px;
}
.couese-comment .comment-author-img {
  width: 42px;
  height: 42px;
  border-radius: 21px 21px;
  overflow: hidden;
  margin-right: 12px;
  flex-shrink: 0;
}
.couese-comment .comment-deatil {
  flex-grow: 10;
  /* border: 1px solid #eee; */
}
.comment-deatil .comment-author-name {
  font-size: 12px;
  color: #333333;
  margin-bottom: 12px;
}
.comment-content-textarea {
  resize: none;
  width: 100%;
  border: none;
  background: #efefef;
  padding: 5px;
}
.comment-comment-content-textarea {
  resize: none;
  width: 100%;
  border: 1px solid #eee;
  background: #fff;
  margin-top: 10px;
}
.comment-but {
  text-align: right;
}
.comment-but .submit {
  margin-right: 0;
  margin-top: 20px;
}
/* 右侧 */
.course .course-right {
  width: 315px;
}
.main-teacher {
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;
}
.main-teacher .teacher .techer-img {
  text-align: center;
}
.techer-img img {
  overflow: hidden;
  border-radius: 34px;
  border: 5px solid #eee;
  cursor: pointer;
  user-select: none;
}
.techer-img .techer-name {
  padding-top: 12px;
  padding-bottom: 20px;
  font-size: 14px;
  color: #333333;
}
.techer-name .techer-name-span {
  cursor: pointer;
  user-select: none;
}
.techer-instr {
  text-align: left;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  line-height: 25px;
}
.user-list {
  display: flex;
  flex-wrap: wrap;
}
.user-list .user-info {
  text-align: center;
  width: 50px;
  cursor: default;
  /* width: 100%; */
}
.user-info .user-img {
  border-radius: 24px;
  margin-bottom: 10px;
}
.user-list .margin-left {
  margin-left: 25px;
}
.course-list .course-name {
  font-size: 14px;
  display: flex;
  user-select: none;
  cursor: pointer;
}
.course-list .course-name:hover {
  color: #1d65a8;
}
/* .course-list .course-name .course-name-middle{} */
.but-loading {
  opacity: 0.5;
}
.forbidden {
  cursor: not-allowed;
}
/* 章节树 */
/* .el-tree-node__content>.el-tree-node__expand-icon{
  left: 10px !important;
  } */
.jt[data-v-1fcfe7be] {
  padding-top: 3px;
  margin-left: 5px;
  margin-right: 5px;
}
.breadcrumb {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cusService {
  cursor: pointer;
  .img_cusService {
    width: 20px;
    height: 20px;
  }
}
/* 推荐课程样式 */
.courseBoxList {
  /* border: 1px solid #000; */
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
  align-content: flex-start;
}
.courseDiv {
  width: 283px;
  /* height: 149px; */
  /* border: 1px solid #000; */
  margin: 0 0 20px 0;
  overflow: hidden;
  background: #fff;
}
.course-margin {
  margin-left: 19px;
}
.course-img {
  cursor: pointer;
  width: 283px;
  height: 160px;
}
.recCourse-name {
  margin-top: 10px;
  padding-left: 12px;
  /* height: 22px; */
  line-height: 22px;
  font-size: 16px;
  color: #262626;
  cursor: pointer;
  user-select: none;
}
.recCourse-name:hover {
  color: #1d65a8;
}
.recCourse-info {
  padding: 0 5px 10px 12px;
  line-height: 20px;
  font-size: 14px;
  color: #999;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.isFinished {
  width: 566px;
  height: 110px;
}
.isFinished img {
  width: 100px;
  margin: 0 auto;
  display: block;
}
.isFinishedMessage {
  width: 100%;
  text-align: center;
  font-size: 16px;
  height: 50px;
  line-height: 50px;
}
.countDownBox p {
  color: white !important;
}
.seckillBox {
  width: 590px;
  height: 40px;
  line-height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #1d65a8;
  color: white;
  padding: 0 20px;
}
/* 课程大纲 */
.custom-tree-node{
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  .el-tag{
    padding: 0 3px!important;
    height: auto!important;
    line-height: 16px!important;
    margin: 0px 10px;
  }
}
</style>
<style lang="scss">
// aliplayer设置 隐藏清晰度 音轨
.prism-setting-quality,.prism-setting-audio,.prism-setting-cc{
  display: none;
}
div::-webkit-scrollbar {
  width: 8px;
  height: 10px;
  /**/
}
</style>
